<script setup lang="ts"></script>

<template>
    <div class="flex items-center justify-center w-full h-full px-6 py-24">
        <div class="relative w-full">
            <Loader />
        </div>
    </div>
</template>
